import PropTypes from 'prop-types';
import React from 'react';

import Conversation from 'models/conversation';
import ConversationTopicsContainerV2 from 'components/customer/conversation_history/topics_v2/conversation_topics_container_v2';
import CustomerContext from 'components/customer/customer_context';

export function ConversationTopics({ onMenuOpenChange, openRequestedAt }) {
  return (
    <CustomerContext.Consumer>
      {({ customerId, latestConversationId, latestConversationStatus }) => {
        if (!latestConversationId || latestConversationStatus === Conversation.Status.CLOSED) {
          return null;
        }

        return (
          <ConversationTopicsContainerV2
            conversationId={latestConversationId}
            customerId={customerId}
            onMenuOpenChange={onMenuOpenChange}
            openRequestedAt={openRequestedAt}
          />
        );
      }}
    </CustomerContext.Consumer>
  );
}

ConversationTopics.propTypes = {
  onMenuOpenChange: PropTypes.func,
  openRequestedAt: PropTypes.string,
};

export default ConversationTopics;
